import { render, staticRenderFns } from "./ModalLicenceApplication.vue?vue&type=template&id=00077c96&scoped=true&"
import script from "./ModalLicenceApplication.vue?vue&type=script&lang=ts&"
export * from "./ModalLicenceApplication.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLicenceApplication.vue?vue&type=style&index=0&id=00077c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00077c96",
  null
  
)

export default component.exports